<template>
  <div>
    <!-- 大数据处理中心头部菜单 -->
    <schoolhome v-if="fromFrame == false && toVeriQueryShow == false" />
    <div class="verifi-img" v-if="scopeValidate">
      <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/NoAccessRights.svg" />
      <p>未设置管辖范围，请设置后查看</p>
    </div>
    <el-container class="absolute-el-con min-box-1200" v-loading.fullscreen="fullScreenLoading" :style="fromFrame == true
        ? 'top:0;height: calc(100% - ' + topheight + ');'
        : 'height:calc(100% - 60px);'
      " v-show="toVeriQueryShow == false">
      <!-- 大数据处理中心左边菜单 -->
      <treeMenu :menuData="menuData" v-on:childTreeMethods="childTreeMethods" v-on:searchMenuData="searchMenuData"
        v-if="fromFrame == false"></treeMenu>

      <el-main class="nopadding" id="organization">
        <el-col :span="24" v-if="!userId" id="subBtn">
          <div class="bread-crumbs" v-if="naxText">
            <span>{{ naxText.father }}</span>
            >
            <span>{{ naxText.child }}</span>
          </div>
          <el-row style="text-align: right;padding-bottom: 20px;padding-top: 10px;">
            <el-col :span="18" class="searchList">
              <!-- 搜索 -->
              <div class="inputArea">
                <el-input style="width: 250px;" size="small" class="list-search" placeholder="搜索标题"
                  v-model="otherSearch.key" prefix-icon="el-icon-search" @keyup.enter="searchBtn(0)"></el-input>
                <el-button size="small" type="primary" @click="searchBtn(0)">搜索</el-button>
              </div>
              <!-- 显示设置 -->
              <el-button class="settingStyle" size="mini" plain @click="getuserreport"
                style="color: #333333;font-size: 14px;" :disabled="listData.data.length > 0 ? false : true"
                v-show="!blockchainChange">
                <i class="iconfont icon-shezhi" style="color: #f09a38;"></i>
                显示设置
              </el-button>
              <!-- 批量操作 -->
              <div class="batch" v-show="!blockchainChange">
                <i class="iconfont icon-piliangcaozuo" style="color: #999999"></i>
                <el-dropdown @command="handleCommand" placement="bottom-start" trigger="click">
                  <span class="el-dropdown-link">
                    <span class="title">批量操作</span>
                    <i style="font-size: 8px;" class="iconfont icon-gengduo"></i>
                  </span>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item command="批量导入"
                        v-show="menuListDatas.length > 0 && menuListDatas[0].import">批量导入</el-dropdown-item>
                      <el-dropdown-item command="批量删除"
                        v-show="menuListDatas[0] && menuListDatas[0].delete">批量删除</el-dropdown-item>
                      <el-dropdown-item command="批量修改"
                        v-if="menuListDatas[0] && menuListDatas[0].batchupdate">批量修改</el-dropdown-item>
                      <el-dropdown-item command="批量导出报表"
                        v-show="listData && listData.data.length > 0 && menuListDatas[0].export ? true : false">批量导出报表</el-dropdown-item>
                      <el-dropdown-item command="批量导出附件"
                        v-show="listData && listData.data.length > 0 && menuListDatas[0].exportfile ? true : false">批量导出附件</el-dropdown-item>
                      <el-dropdown-item command="上传区块链"
                        v-if="menuListDatas[0] && menuListDatas[0].uploadblockchainid">上传区块链</el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
              <!-- 上传区块链 -->
              <div class="blockchain" v-show="blockchainChange">
                <div class="upload">
                  <el-button size="small" @click="blockchainChange = !blockchainChange">取消</el-button><el-button
                    type="primary" size="small" @click="blockchainUpload">上传区块链</el-button>
                </div>
              </div>
              <!-- 数据筛选 -->
              <el-button type="text" style="color: #333333;" class="nav-top-filter" @click="isFilter = true">
                <i class="iconfont icon-shaixuanmian" style="color: #19B359;font-size: 14px;margin-right: 3px;"></i>
                <span>数据筛选</span>
                <i style="font-size: 8px;color:#999999" class="iconfont icon-gengduo" />
              </el-button>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="24" style="padding-bottom:50px;height: calc(100% - 160px);" id="table-list">

          <el-table :data="listData.data" border :stripe="true"
            :header-cell-style="{ background: '#f8f9fb', color: '#333', fontWeight: 'normal' }" height="100%"
            ref="transactions" @row-click="tableDetail" :key="uploadKey" :header-cell-class-name="'header_style'"
            :row-class-name="upClass" :row-style="{ height: '22px' }" @selection-change="handleSelectionChange">
            <el-table-column type="selection" :selectable="selectableFun" width="40"></el-table-column>
            <el-table-column :prop="val.title" v-for="val in tableKey" :min-width="val.width" :key="val.id">
              <template v-slot:header>
                <div class="ellipsisTwo" :title="val.name">{{ val.name }}</div>
              </template>
              <template v-slot="scope">
                <el-popover placement="right" width="400" trigger="hover" v-if="
                  scope.row[val.title] && scope.row[val.title].list
                ">
                  <div>
                    <p v-for="item in scope.row[val.title].list" :key="item.id">
                      <span v-for="(item1, index) in item" :key="item1.id">{{ index }}：{{ strData(item1) }}</span>
                    </p>
                  </div>
                  <template #reference>
                    <el-button type="text">{{ scope.row[val.title].value }}</el-button>
                  </template>
                </el-popover>
                <div v-else>
                  <span v-if="val.title === '状态'" :class="statusFun(scope.row[val.title])">{{ scope.row[val.title]
                    }}</span>
                  <span v-else-if="val.type === 'richTextWid'">富文本请到详情内查看</span>
                  <div class="ellipsisTwo" :title="strData(scope.row[val.title])" v-else>
                    <template v-if="val.type === 'date' && val.match && val.match === 'yyyy-MM-dd ww'">
                      {{ strData(scope.row[val.title], val.encrypt) }} {{ '星期' + getWeek(strData(scope.row[val.title],
                      val.encrypt)) }}
                    </template>
                    <template v-else-if="val.type === 'date'">
                      {{ getTimeLabels(val, scope) }}
                    </template>
                    <span v-else-if="val.type === 'text' && isLinkObj[val.title]" class="text-link"
                      @click.stop="openLinkText(scope.row[val.title])">
                      {{ strData(scope.row[val.title], val.encrypt) }}
                    </span>
                    <span v-else-if="val.type === 'radio' && val.sels && val.types && val.types === 6">
                      <radioXing :sels="val.sels" :value="scope.row[val.title]" />
                    </span>
                    <template v-else>
                      {{ strData(scope.row[val.title], val.encrypt) }}
                    </template>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120" v-if="
              (menuListDatas[0] && menuListDatas[0].update) ||
              (menuListDatas[0] && menuListDatas[0].delete) ||
              (menuListDatas[0] && menuListDatas[0].archive)
            ">
              <template v-slot="scope">
                <!--                        v-if="blockchaiButtonShow(scope.row) === true"-->
                <div @click.stop>
                  <el-tooltip v-if="scope.row.cochain && (scope.row.cochain === 1 || scope.row.cochain === 2)"
                    class="item" effect="dark" content="已上区块链" placement="top">
                    <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/link.svg" />
                  </el-tooltip>
                  <el-button @click.stop="tableUpdate(scope.row)" v-if="menuListDatas[0].update" type="text"
                    size="small" style="color: #267CFF;font-size: 14px;"><i
                      class="iconfont icon-bianji" /></el-button>
                  <el-button @click.stop="tableDelete(scope.row)" v-if="menuListDatas[0].delete" type="text"
                    size="small" style="color: #E5283F;font-size: 14px;"><i
                      class="iconfont icon-shanchu5" /></el-button>
                  <el-button v-if="menuListDatas[0].areaoplog" @click.stop="viewLogFun(scope.row)" type="text"
                    size="small" style="color: #F7A114;font-size: 14px;"><i
                      class="iconfont icon-chakanxiangqing1" /></el-button>
                  <template v-if="menuListDatas[0].oqrcore">
                    <!--                            <span class="parting"></span>-->
                    <el-dropdown @command="onQrcodeCommand">
                      <span class="el-dropdown-link" style="padding: 0 0 0 6px">
                        <i class="iconfont icon-erweima- qrcode"></i>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item v-if="menuListDatas[0].oqrcore === 1 || menuListDatas[0].oqrcore === 2"
                            :command="{
                              channel: 'mini',
                              type: 1,
                              approvingId: scope.row.approvingId,
                              customTitle: scope.row['自定义标题'],
                              approvalId: appid,
                            }">生成小程序端静态二维码</el-dropdown-item>
                          <el-dropdown-item v-if="menuListDatas[0].oqrcore === 1 || menuListDatas[0].oqrcore === 3"
                            :command="{
                              channel: 'mini',
                              type: 2,
                              approvingId: scope.row.approvingId,
                              customTitle: scope.row['自定义标题'],
                              approvalId: appid,
                            }">生成小程序端动态二维码</el-dropdown-item>
                          <el-dropdown-item v-if="menuListDatas[0].oqrcore === 1 || menuListDatas[0].oqrcore === 4"
                            :command="{
                              channel: 'h5',
                              type: 1,
                              approvingId: scope.row.approvingId,
                              customTitle: scope.row['自定义标题'],
                              approvalId: appid,
                            }">生成H5端静态二维码</el-dropdown-item>
                          <el-dropdown-item v-if="menuListDatas[0].oqrcore === 1 || menuListDatas[0].oqrcore === 5"
                            :command="{
                              channel: 'h5',
                              type: 2,
                              approvingId: scope.row.approvingId,
                              customTitle: scope.row['自定义标题'],
                              approvalId: appid,
                            }">生成H5端动态二维码</el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                  <el-button v-if="JSON.stringify(scope.row.archive) && archiveUser" type="text" size="small"
                    @click.stop="archiveFun(scope.row)" :title="scope.row.archive ? '解除归档' : '归档'"
                    :style="{ color: scope.row.archive ? '#9013FE' : '#999999' }"><i
                      class="iconfont icon-guidang" /></el-button>
                </div>

                <!-- 区块链操作 -->
                <!--                        <div v-else>已上区块链</div>-->
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <div class="page" id="pag">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :page-size="listData.pagesize" :page-sizes="[20, 30, 40, 50]"
            layout="total, sizes, prev, pager, next, jumper" :total="listData.total"></el-pagination>
          <!--:current-page.sync="currentPage"-->
        </div>
      </el-main>
    </el-container>

    <el-dialog :title="dialogFieldSet.title" v-model="dialogFieldVisible" class="dialognewclass" width="530px">
      <el-row class="dialog-body">
        <template>
          <el-checkbox-group v-model="checkShowSet" @change="fieldChange">
            <!--<el-checkbox v-for="showSet in showSets" :label="showSet" :key="showSet.id" style="margin:0 10px"  disabled="true">{{showSet.name}}</el-checkbox>-->
            <el-checkbox v-for="showSet in showSets" :label="showSet" :key="showSet.id" style="margin: 0 10px"
              :disabled="(showSet.type == 'details' || showSet.type == 'container') && dialogFieldSet.botton == 1
                  ? true
                  : false
                ">{{ showSet.name }}</el-checkbox>
          </el-checkbox-group>
        </template>
      </el-row>
      <el-row class="dialog-foot">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllField"
          @change="fieldAllChange">全选</el-checkbox>
        <div>
          <el-button type="primary" size="small" @click="exportexcel" :loading="exportexcelLoading ? true : false"
            element-loading-text="数据加载中" v-if="dialogFieldSet.botton == 0">导出</el-button>
          <el-button type="primary" size="small" @click="FieldSubmit" v-else>确定</el-button>
          <el-button size="small" @click="dialogFieldVisible = false">取消</el-button>
        </div>
      </el-row>
    </el-dialog>
    <vue-qr-code ref="vueqrcoderef" v-if="dialogvueqr" />
    <!-- 表单详情 -->
    <oaExamineAudit ref="AuditOpenChild" @callParent="oaExAuditCallBack" v-on:sourceAudit="sourceAudit">
    </oaExamineAudit>
    <form-data-modify ref="formDataModifyChild"></form-data-modify>
    <!-- 批量下载附件 -->
    <accessory ref="accessoryRef" v-if="downLoadShow" :date="listData.data"></accessory>
    <!-- 表单验证过滤 -->
    <VerificationAndQueryInput ref="VerificationAndQueryInputRef" :approvalId="$route.query.approvalId || appid"
      :number="3" @toVerificationAndQuery="formVerificationAndQuery" />
    <smsVerifiction ref="smsVerifi" :approvalId="$route.query.approvalId || appid" type="1" v-show="toSmsVerifi"
      @smsRefersh="smsRefersh" />
    <!-- 搜索 -->
    <transactionFilter v-model:isFilter="isFilter" v-model:condition="query" @goFilter="goFilter" />
    <!-- 日志查看 -->
    <log v-model:isLogView="isViewLog" :approvalId="$route.query.approvalId || appid" :approvingId="logApprovingId" />
    <batchDialog :visible="batch.visible" :date="batch" :approvalId="$route.query.approvalId || appid"
      @batch="batchRet" />
    <widgetLinkOpen ref="widgetLinkOpen" :linkConfig="linkconfig" diaSize="80%" />
    <div id="ments"></div>
  </div>
</template>

<script>
import { axiosBase } from "@/api/api";
import treeMenu from '../common/treeMenu.vue';
// import formDataModify from './popup/formDataModify';
import schoolhome from '../../schoolHome.vue';
import { tableStat, generateTime, searchNav, getConfigFromUrl } from '@/api/utils'
import {
  sliceEncrypt,
  filePreview
} from "@/api/global.js";
import accessory from './accessory.vue';
import VerificationAndQueryInput from '../VerificationAndQueryInput'
import smsVerifiction from '@/components/clientSide/common/smsVerifiction.vue'
import { openapiValidateapprovalsms, getapifielddatalist, getopenreportformlist, getvalidateapproval, archivedata, deletebycondition, batchupdatedata } from '@/port/clientSide/workbench'
import vueQrCode from '@/components/clientSide/common/vueQrCode'
import {
  addcochain
} from '@/port/clientSide/oaExamineAudit'
import { timeFormatDate } from "../../../api/global";
import { getShowconfig } from '@/api/drage'
import { getWeek } from '@/api/styleUtils'
import { ElMessage } from 'element-plus'
import radioXing from '@/components/clientSide/formFillinPageChild/widgetCommon/radioXing.vue'
import { getTMbulkImportParam } from '@/components/schoolInstrument/component/mutual/common/config'
import { defineAsyncComponent } from "vue";

export default {
  name: 'organizationCpn',
  components: {
    treeMenu,
    // oaExamineAudit: defineAsyncComponent(() => import('../oaExamineAudit.vue')),
    // formDataModify,
    schoolhome,
    accessory,
    VerificationAndQueryInput,
    smsVerifiction,
    transactionFilter: defineAsyncComponent(() => import('./transationFilter/index')),
    vueQrCode,
    radioXing,
    log: defineAsyncComponent(() => import('./log/index')),
    batchDialog: defineAsyncComponent(() => import('./batchDialog/index')),
    widgetLinkOpen: defineAsyncComponent(() => import('@/components/clientSide/common/widgetLinkOpen.vue'))
  },
  filters: {
    cutOutText(value) {//获取两个时间的差别是几天
      return value.split("_")[0];
    },
  },
  // appid 这个是应用id，他是由组建过来替代以前直接从url 上获取的id
  // external 外链
  props: ['appid', 'externals', 'importSet'],
  data() {
    return {
      topheight: '60px',
      tableHeight: null,
      timeArr: [],  //时间合集
      fullScreenLoading: false,
      fromFrame: false,
      userId: false,//个人报表或者学校报表
      menuListActive: 0,
      menuData: [],//最左边树形菜单使用得数据
      menuListDatas: [],//中间菜单显示得数据
      query: [],//搜索列表数据
      querys: null,//验证过滤使用，如果有过滤数据，就走这个过滤
      searchMore: false,
      menuListW: false,
      activeName: 'first',
      firstSearch: { appname: '', status: '' },
      tableKey: [],
      showSets: [],//显示设置全部
      checkShowSet: [],//显示设置选中
      isIndeterminate: true,//全选使用
      dialogFieldVisible: false,
      dialogFieldSet: {
        title: '设置导出字段',
        botton: 0,
      },
      exportexcelLoading: false,
      checkAllField: false,
      userReportId: null,//提交显示字段ID
      listData: { data: [] },
      otherSearch: { type: 0, curpage: 1, pagesize: 20, cateId: "-1", key: "" },
      bulkDeleteDataArr: [],//批量删除
      // currentPage:1,//当前页码
      naxText: null,
      heightCount: null, //计算高度的函数
      //- 批量整合
      downLoadShow: false,
      toVeriQueryShow: true,//- 是否开启过滤验证数据
      toSmsVerifi: false, // 是否开启短信验证
      isSmsFun: {},  // 是否进行过短信验证
      dialogvueqr: false,
      //- 区块链按钮显示
      blockchainChange: false,
      uploadKey: 0,
      isFilter: false, // 数据筛选开关
      scopeValidate: false, // 管辖数据是否有开启验证查询
      // 查看日志
      isViewLog: false,
      logApprovingId: '',
      // 批量修改等使用
      batch: {
        visible: false,
        title: '',
        operate: ''
      },
      // 归档
      archiveUser: false,
      searchQuery: {},
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
      isLinkObj: {},
      // 链接配置
      linkconfig: {
        open: false,
        terrace: false,
        link: false,
        field: '',
        openConfig: 'original'
      }
    }
  },
  created() {
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof (spaceId) !== 'undefined' || spaceStatus) {
      this.isSpace = true
    }
    else if (typeof (upaceId) !== 'undefined' || upaceStatus) {
      this.isUpace = true
    }
  },
  watch: {
    listData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && val.data && val.data.length > 0 && val.data[0].content && val.data[0].content.length > 0) {
          const obj = {}
          for (const i of val.data[0].content) {
            if (i && i.type === 'text' && i.isLink && i.isLink === 'true') {
              obj[i.title] = true
            }
          }
          this.isLinkObj = obj
        } else {
          this.isLinkObj = {}
        }
      }
    },
  },
  methods: {
    openLinkText(val) {
      console.log('ssss', val)
      window.open(val)
    },
    getTimeLabels(val, scope) {
      if (!val || !scope) return ''
      if (val.type === 'date' && scope.row[val.title] && val.timeList && val.timeList.open && val.timeList.options && val.timeList.options.length > 0) {
        const label = this.getTimeLabel(scope.row[val.title], val.timeList.options)
        return label
      }
      // if (scope.row.content && scope.row.content.length > 0) {
      //   for (const i of scope.row.content) {
      //     if (i.title === val.title && i.timeList) {
      //       const timeList = JSON.parse(i.timeList)
      //       if (timeList.open && timeList.options && timeList.options.length > 0 && i.value) {
      //         const label = this.getTimeLabel(i.value, timeList.options)
      //         return label
      //       }
      //     }
      //   }
      // }
      let value = this.strData(scope.row[val.title], val.encrypt)
      if (value && value.includes('1970-01-01')) {
        try {
          value = value.split(' ')[1].split(':').slice(0, 2).join(':')
        } catch (err) { console.log(err) }
      }
      return value
    },
    getWeek(val) {
      return getWeek(val)
    },
    // 归档 or 解除归档
    async archiveFun(item) {
      const res = await archivedata({
        approvalId: this.$route.query.approvalId || this.appid,
        approvingId: item.approvingId,
        isarchive: item.archive ? 0 : 1
      })
      if (res.code === 0) {
        this.$message.success(item.archive ? '解除归档成功！' : '归档成功！')
        item.archive = !item.archive
      }
    },
    // 批量回来
    batchRet(val) {
      if (this.batch.operate === 'del') {
        // 等新接口
        if (val.radio === 1) {
          const param = {
            isAll: 2,
            approvingId: (this.bulkDeleteDataArr || []).map(its => its.approvingId),
          };
          this.eletedFunction(param)
        } else {
          this.setDeletebycondition(val)
        }
      } else if (this.batch.operate === 'export') {
        console.log('批量导出回来', val)
        this.checkShowSet = (val.center || []).filter(item => {
          return item.checked
        })
        this.exportexcel(val)
      } else if (this.batch.operate === 'update') {
        // 这里是修改回来
        console.log('修改回来', val)
        const obj = {
          approvalId: this.appid || this.$route.query.approvalId,
          reportFormId: this.otherSearch.reportFormId,
          type: 0,
          curpage: 1,
          pagesize: 10000,
          cateId: -1,
          key: this.otherSearch.key,
          conditionconfig: val.conditionconfig
        }
        if (val && val.radio === 1) {
          obj.approvingIds = (this.bulkDeleteDataArr || []).map(its => its.approvingId).join(',')
        } else if (val && val.radio === 2) {
          obj.query = this.otherSearch.query
        } else if (val && val.radio === 3) {
          obj.query = { 'date_timeof': val.time }
        }
        if (val.isarchive !== '') obj.isarchive = val.isarchive
        this.batchUpdate(obj)
      }
      this.batch = {
        visible: false,
        title: '',
        operate: ''
      }
    },
    // 批量修改
    async batchUpdate(item) {
      const res = await batchupdatedata(item)
      if (res.code === 0) {
        ElMessage({ type: "success", message: "操作成功" })
        this.switClick()
        this.$emit('retRefresh')
      } else {
        ElMessage({ type: "error", message: res.msg || '操作失败' })
      }
    },
    // 批量删除
    async setDeletebycondition(item) {
      const param = {
        approvalId: this.$route.query.approvalId || this.appid,
        reportFormId: this.otherSearch.reportFormId,
        type: 0,
        curpage: 1,
        pagesize: 10000,
        cateId: -1,
        key: this.otherSearch.key
      };
      if (item && item.radio === 2) {
        param.query = this.otherSearch.query
      } else if (item && item.radio === 3) {
        param.query = { 'date_timeof': item.time }
      }
      this.fullScreenLoading = true
      const res = await deletebycondition(param)
      if (res.code === 0) {
        this.$message.success(res.msg || '删除成功!')
        // 判断当前删除之后，是否没有数据，没有的话回退一页分页查询数据
        if (this.listData.data.length === 0 && this.otherSearch.curpage > 1) {
          this.otherSearch.curpage -= 1;
        }
        // 重新请求列表数据
        this.switClick();
        // parent.vueFun('resetRefresh')
        this.$emit('retRefresh')
      } else {
        this.$message.error(res.msg || '删除成功!')
      }
      this.fullScreenLoading = false
    },
    // 查看日志
    viewLogFun(item) {
      this.logApprovingId = item.approvingId;
      this.isViewLog = true
    },
    // 搜索
    goFilter(e) {
      if (JSON.stringify(e) !== '{}') {
        this.otherSearch.query = JSON.stringify(e);
      } else {
        delete this.otherSearch.query
      }
      //搜索设置值
      this.otherSearch.curpage = 1;
      this.otherSearch.pagesize = 20;
      this.switClick();
    },
    //- 区块链上链
    blockchainUpload() {
      const that = this;
      let tableDataChe = that.bulkDeleteDataArr;
      if (tableDataChe.length === 0) {
        that.$message.error('请选择要上链的数据');
      } else {
        let id_array = tableDataChe.map((item) => {
          return item.approvingId
        })
        let param = {};
        param.approvalId = that.menuListDatas[0].approvalId;
        param.approvingIds = id_array;

        addcochain(param).then(res => {
          if (res.code === 0) {

            setTimeout(() => {
              that.$message.success('上链成功')
              that.uploadKey += 1;
              that.switClick();
            }, 500)


          } else {
            that.$message.error(res.msg);
          }
        }).catch(error => {
          console.log('区块链上链报错', error)
        })



      }
    },
    //- 判断当上传区块链时候是否展示按钮
    blockchaiButtonShow(row) {
      //- cochain   上链0:无操作，1是上链中，2上链成功，3上链失败
      let whether = true;
      if (row.cochain === 1 || row.cochain === 2) {
        whether = false;
      }
      return whether

    },
    //- 表单selec是否可以选中
    selectableFun(row) {
      //- cochain   上链0:无操作，1是上链中，2上链成功，3上链失败
      let whether = true;
      if (this.blockchainChange === true) {
        //- 区块链模式下
        //- 上链失败，无操作不能选中
        if (row['状态'] !== '已通过') {
          whether = false;
        } else {
          // if (row.cochain === 1 || row.cochain === 2) {
          //   whether = false;
          // }

        }
      } else {
        //- 正常模式下
        // if (row.cochain === 1 || row.cochain === 2) {
        //   whether = false;
        // }
      }
      //- return 值true是可以，false是不行
      return whether
    },
    //- oaExamineAudit表单组件回调
    oaExAuditCallBack() {
      alert("oaExamineAudit表单组件回调")
    },
    //- 表格名称判断
    upClass({ row }) {
      let str = 'row_style'
      //- cochain   上链0:无操作，1是上链中，2上链成功，3上链失败
      if (row.cochain === 1 || row.cochain === 2) {
        str += ' row_style_back'
      }
      return str
    },
    //- 批量导出附件是否显示判断
    panduanShow(listData) {
      let whether = '';
      if (listData && listData.data.length > 0 && (this.$route.query.approvalId || this.appid) != 10288 && (this.$route.query.approvalId || this.appid) != 10318 && (this.$route.query.approvalId || this.appid) != 10156) {
        whether = true;
      } else {
        whether = false;
      }
      return whether;

    },
    //- 获取批量导出传递数据
    getTransmitDatas() {
      let otherSearch = JSON.parse(JSON.stringify(this.otherSearch));
      let param = {
        reportFormId: otherSearch.reportFormId,//- 报表ID
        zipcontent: '',//- 附件下载配置文件
        ziptype: 0,//- 0：全校；1个人
        approvalId: this.$route.query.approvalId || this.appid,//- 	应用ID
        approvingIds: '',//- 选择数据时拼接ID
        key: otherSearch.key,//- 搜索标题或发起人名称
        query: otherSearch.query,//- 筛选条件
        type: 0,//- 后台要的（模式固定，前端不在改了）
        cateId: '-1',//- 后台要的（模式固定，前端不在改了）
        // key: '',//- 后台要的（模式固定，前端不在改了）
      }
      //- 确认是否有选择id
      if (this.bulkDeleteDataArr.length > 0) {
        //- 说明有选择id，需要拼接
        let id_array = [];
        this.bulkDeleteDataArr.forEach((item) => {
          id_array.push(item.approvingId);
        })
        id_array = id_array.join(",");
        param.approvingIds = id_array;
      }


      return param;
    },
    // 遍历加东西
    findAdd(val) {
      //- type代表当前数据，title代表fathertype值，val代表当前循环的list数据
      let new_array = [];//- 新数组
      let datas = JSON.parse(JSON.stringify(val));
      for (let index = 0; index < datas.length; index++) {
        if (['ready-widget', 'label', 'checkbox', 'richTextWid'].indexOf(datas[index].type) === -1) {
          //- 第一级fathertype补全
          if (datas[index].fatherType == undefined) {
            //- 说明字段fatherType不存在就要补全
            datas[index].fatherType = '';
          }
          //- 明细或者新版管联数据判断
          let list_one = datas[index].list;
          if (list_one && list_one.length > 0) {
            //- 可能是明细还是关联单选控件
            list_one.forEach((item) => {


              item.fatherType = datas[index].title + '_' + datas[index].type;
              item.name = datas[index].name + "." + item.name;

              //- 明细可能有第二层list数据
              let second_list = item.list;
              if (second_list && second_list.length > 0) {
                second_list.forEach((item2) => {
                  if (['ready-widget', 'label', 'checkbox', 'richTextWid'].indexOf(item2.type) === -1) {


                    item2.name = item.name + "." + item2.name;
                    item2.fatherType = datas[index].title + '_' + datas[index].type + "." + item.title + '_' + item.type;
                    item2.tier = 3;
                    new_array.push(item2);
                  }

                })
              } else {
                //- 说明没有下一层数据就直接加入数据
                if (['ready-widget', 'label', 'checkbox', 'richTextWid'].indexOf(item.type) === -1) {
                  item.tier = 2;
                  new_array.push(item);
                }

              }


            })

          } else {
            //- 当前没有没有明细数据或者关联数据(第一级)

            datas[index].tier = 1;
            new_array.push(datas[index]);


          }
        }

      }
      return new_array;
    },
    //- 获取当前表单的字段
    getFrom() {
      let that = this;
      const obj = { approvalId: this.$route.query.approvalId || this.appid }
      if (this.$route.query.spaceid || localStorage.getItem('spaceid')) {
        obj.spaceid = this.$route.query.spaceid || localStorage.getItem('spaceid')
      }
      else if (this.$route.query.upaceid || localStorage.getItem('upaceid')) {
        obj.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
      }
      axiosBase(obj, "/openapi/getapproval").then(async res => {
        if (res.code === 0) {
          let field = JSON.parse(res.data.property);
          const appname = res.data.appname
          field = field.filter(val => {
            if (val.list && val.list.length > 0) val.list = (val.list).filter(items => { return items.type !== 'label' });
            return val.type !== 'label'
          });
          // 遍历给每个有list 的参数加东西
          field = that.findAdd(field);

          const list = getShowconfig(res.data.showconfig || '')
          list.splice(list.length - 1, 1)
          field = list.concat(field)

          // field.unshift({ name: '申请人', type: 'relation-user', title: '申请人', fatherType: '', tier: 1 },
          //   { name: '单号', type: 'text', title: '单号', fatherType: '', tier: 1 },
          //   { name: '状态', type: 'status', title: '状态', fatherType: '', tier: 1 },
          //   { name: '提交时间', type: 'date', title: '提交时间', fatherType: '', tier: 1 });



          let arrs = [];//- 最后转换的数据内容

          field.forEach((val) => {
            let date = {
              type: val.type,
              name: val.name,
              title: val.title,
              fatherType: val.fatherType,
              tier: val.tier
            };
            if (val.sels) date.sels = typeof val === 'string' ? JSON.parse(val.sels) : val.sels;
            arrs.push(date);
          });

          // 获取一下打印模板
          let printConfig
          if (res.data && res.data.pageset) {
            printConfig = JSON.parse(res.data.pageset)
            if (printConfig && printConfig.url) {
              printConfig = await getConfigFromUrl(this.$url + printConfig.url)
            }
          }
          this.$nextTick(() => {
            this.$refs.accessoryRef.setFromDatas(arrs, printConfig, appname);
          })
        }
      })
    },
    //- 批量操作
    handleCommand(val) {
      if (val == '批量导入') {
        this.bulkImport(this.menuListDatas);
      } else if (val == '批量导出附件') {
        this.transactionListFun = 'batchFileFun';
        if (this.isSmsFun['batchFileFun'] || this.external) {
          this.smsRefersh();
        } else {
          this.smsVerifi(5);
        }
      } else if (val == '批量删除') {
        // this.bulkDelete()
        this.batch = {
          visible: true,
          title: '删除',
          operate: 'del',
          repeat: true,
          batchQuery: this.otherSearch.query || '',
          dateLen: this.bulkDeleteDataArr.length
        }
      } else if (val == '批量导出报表') {
        this.transactionListFun = 'getuserreport';
        if (this.isSmsFun['getuserreport'] || this.external) {
          this.smsRefersh();
        } else {
          this.smsVerifi(6);
        }
      } else if (val == '上传区块链') {
        this.blockchainChange = true;
        this.switClick();
      } else if (val == '批量修改') {
        this.batch = {
          visible: true,
          title: '修改',
          operate: 'update',
          repeat: true,
          batchQuery: this.otherSearch.query || '',
          dateLen: this.bulkDeleteDataArr.length
        }
      }

    },
    // 批量导出附件
    batchFileFun() {
      this.downLoadShow = true;
      this.getFrom();
      let datas = this.getTransmitDatas();
      console.log(3)
      this.$nextTick(() => {
        this.$refs.accessoryRef.openAccessory(datas, this.querys);
      })
    },
    strData(e, n) {
      if (e instanceof Array) { //如果为数组
        if (e[0] && e[0].userId) { //如果有userId说明是联系人控件
          var ej = [];
          e.forEach(i => {
            ej.push(i.realname)
          });
          return ej.join(',')
        } else {
          return e.join(',')
        }
      } else {
        return sliceEncrypt(e, n)
      }
    },
    statusFun(val) {
      return tableStat(val)
    },
    //计算表头宽度
    async countTable() {
      await this.$nextTick()
      if (this.tableKey.length > 0 && this.listData && this.listData.data && this.listData.data.length > 0) {
        //先计算表头的字符宽度
        let table = JSON.parse(JSON.stringify(this.tableKey))
        let tableArr = []
        for (let i in table) {
          let width = table[i].title.length * 14
          if (width > 400) {
            table[i].width = 400
          } else if (width < 100) {
            table[i].width = 100
          } else {
            table[i].width = width
          }
          tableArr.push(table[i].title)
        }
        //计算表格里面字符数据
        let list = JSON.parse(JSON.stringify(this.listData.data))
        for (let i in list) {
          for (let a in list[i]) {
            //进行匹配
            let index = tableArr.indexOf(a)
            if (index !== -1) {
              let len = list[i][a].length * 14
              if (len > table[index].width && len > 400) {
                table[index].width = 400
              } else if (len > table[index].width && len < 400) {
                table[index].width = len
              }
            }
          }
        }
        this.tableKey = table
      }
      this.obtainHeight()
    },
    obtainHeight() {
      let self = this
      this.$nextTick(function () {
        self.heightCounts()
        //监听
        this.heightCount = window.addEventListener('resize', function () {
          self.heightCounts()
        })
        setTimeout(function () {
          self.$refs.transactions.doLayout()
        }, 10)
      })
    },
    //表格高度计算
    heightCounts() {
      let allHeight = document.getElementById('organization');
      // let dom = document.getElementById('subBtn');
      // let pag = document.getElementById('pag');
      console.log('高度数据u', allHeight)
      let tableStat = allHeight.clientHeight - 20;
      this.tableHeight = tableStat
    },
    searchMenuData(val) {
      if (this.originalArr && this.originalArr.length !== '') {
        this.menuData = searchNav(this.originalArr, val)
      }
    },
    handleSizeChange(val) {
      this.otherSearch.pagesize = val
      this.switClick();
    },
    handleCurrentChange(val) {
      this.otherSearch.curpage = val
      this.switClick();
    },
    searchBtn(key) {
      var query = {};
      this.query.forEach(e => {
        if (e.value && e.value != '' && e.value.length > 0) {
          if (e.type == 'number') {
            var value = []
            if (e.value == '小于等于') {
              value = ['', e.min]
            } else if (e.value == '大于等于') {
              value = [e.min, '']
            } else {
              value = [e.min, e.max]
            }
            query[e.title + '_' + e.type] = value
          } else {
            query[e.title + '_' + e.type] = e.value
          }
        }
      })
      if (key == 0) {
        this.otherSearch.query = JSON.stringify(query);
        //搜索设置值
        this.otherSearch.curpage = 1;
        this.otherSearch.pagesize = 20;
        this.switClick();
      }
    },
    emptyBtn() {
      var query = {}
      this.query.forEach(e => {
        e.value = []
        if (e.type == 'number') {
          e.value = ''
          e.min = ''
          e.max = ''
        }
      })
      this.otherSearch.query = JSON.stringify(query);
      this.otherSearch.type = 0;
      this.otherSearch.curpage = 1;
      this.otherSearch.pagesize = 20;
      this.otherSearch.cateId = '-1';
      this.otherSearch.key = '';
      this.switClick();
    },
    switClick() {
      if (this.menuData.length == 0 && !this.fromFrame) {
        return
      }
      if (!this.otherSearch.reportFormId) return;

      this.fullScreenLoading = true;
      if (this.querys) {
        this.otherSearch.querys = this.querys
      }
      this.otherSearch.datanum = 1  // 区分关系数据的值，只有管辖数据需要
      // 从空间进入，需要传空间id
      if (this.isSpace) {
        let spaceId = typeof (this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        this.otherSearch.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof (this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        this.otherSearch.upaceid = upaceId
      }
      getapifielddatalist(this.otherSearch).then(res => {
        if (res.code === 0) {
          this.listData = res;
          this.countTable()
          this.fullScreenLoading = false;
        }
      }).catch(err => {
        console.log('短信验证错误', err)
      })
    },
    // 查询label
    getTimeLabel(val, sels) {
      if (!val || !sels || sels.length === 0) return val
      const v = val.split(' ')
      for (const i of sels) {
        if (i.value === v[1]) return v[0] + ' ' + i.label
      }
      return val
    },
    menuListMethod(item, key) {
      console.log('item====', item)
      this.menuListActive = key
      this.query = [];
      if (typeof item.query == "string") {
        item.query = JSON.parse(item.query)
      }
      item.query.forEach(e => {
        if (e.checked) {
          if (e.type == 'radio' || e.type == 'checkbox') {
            if (typeof e.sels == "string") {
              e.sels = JSON.parse(e.sels)
            }
            e.value = []
          } else if (e.type == 'status') {
            e.value = []
          } else if (e.type == 'data') {
            // TODO
          }
          this.query.push(e)
        }
      });
      // this.otherSearch = { type: 0, curpage: 1, pagesize: 20, cateId: "-1", key: "" }
      const otherSearch = { type: 0, curpage: 1, pagesize: 20, cateId: "-1", key: "" }
      if (this.$route.query.search) {
        otherSearch.query = this.otherSearch.query
      }
      if (item.reportFormId) {
        otherSearch.reportFormId = item.reportFormId
      }
      otherSearch.approvalId = item.approvalId || this.$route.query.approvalId || this.appid
      /*
            if (item.reportFormId) {
              this.otherSearch.reportFormId = item.reportFormId
            }
            this.otherSearch.approvalId = item.approvalId || this.$route.query.approvalId || this.appid
      */
      this.otherSearch = otherSearch

      if (item.userId) {//个人报表
        this.userId = true;
      } else {//学校报表
        this.userId = false;
      }
      if (item.userReport && item.userReport.content) {
        var content = JSON.parse(item.userReport.content);
        this.tableKey = [];
        for (var i = 0; i < content.length; i++) {
          // 容器控件不显示
          if (content[i].checked && content[i].type !== 'container') {
            this.tableKey.push(content[i])
          }
        }
        this.countTable()
        this.switClick();
      } else {
        alert('表头数据错误')
      }

    },
    childTreeMethods(param) {
      if (param.categoryName && param.appname) {
        this.naxText = {
          father: param.categoryName,
          child: param.appname
        }
      }
      const spaceid = this.$route.query.spaceid
      const upaceid = this.$route.query.upaceid
      const __par = { curpage: 0, pagesize: 0, datatype: 1, approvalId: param.approvalId }
      if (spaceid) {
        __par.spaceid = spaceid
      }
      else if (upaceid) {
        __par.upaceid = upaceid
      }
      if (this.$route.query.space) {
        delete __par.spaceid
        __par.spaceid = spaceid || localStorage.getItem('spaceid')
      }
      else if (this.$route.query.upace) {
        delete __par.upaceid
        __par.upaceid = upaceid || localStorage.getItem('upaceid')
      }
      getopenreportformlist(__par).then(res => {
        if (res && res.code == 0) {
          this.menuListDatas = []
          res.data.forEach(e => {
            if (!e.userId) {
              if (e.archive) this.archiveUser = true
              this.menuListDatas.push(e)
              this.menuListMethod(e, 0);//初始化第一条数据
            }
          });
          this.activeName = 'first';
        }
      }).catch(() => {
        // TODO
      })
    },
    fieldAllChange(val) {
      //显示设置过滤明细控件
      let newArr = [];
      if (this.dialogFieldSet.botton == 1) {
        this.showSets.forEach((el) => {
          if (el.type != 'details' || el.type != 'container') {
            newArr.push(el);
          }
        });
      } else {
        newArr = this.showSets;
      }
      this.checkShowSet = val ? newArr : [];
      this.isIndeterminate = false;
    },
    fieldChange(value) {
      let checkedCount = value.length;
      this.checkAllField = checkedCount === this.showSets.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.showSets.length;
    },
    async tableDetail(row) {
      if (row && row.linkconfig && row.linkconfig.open && row.linkconfig.field && row.linktype && row.linktype === '1') {
        const v = row.linkconfig.field.split('_')[0]
        this.linkconfig = row.linkconfig
        await this.$nextTick()
        this.$refs.widgetLinkOpen.open(row[v])
        return
      }
      let param = {
        approving: {
          approvingId: row.approvingId,
        },
        userapprovingId: row.userApprovingId,
        approvalId: this.$route.query.approvalId || this.appid
      };
      this.$refs.AuditOpenChild.AuditOpenList(param, 1);
    },
    sourceAudit(param) {//来源oaExamineAudit.vue的方法
      if (param.key == 0) {
        this.secondData.data.forEach((el, index) => {
          if (el.userapprovingId == param.userapprovingId) {
            this.secondData.data.splice(index, 1);
            this.secondnum = this.secondnum - 1;
          }
        });
        this.thirdData = null;
      }
    },
    async bulkImport(e) {
      var approvalId = e[0].approvalId;
      const obj = await getTMbulkImportParam(approvalId, true, this.importSet)
      if (obj && obj.openType !== 'old' && obj.openType !== 'new') {
        this.$emit('open-appDialog', obj)
      }
    },
    getuserreport(key) {//显示设置
      if (key == 0) {//0为导出字段
        this.dialogFieldSet = {
          title: '设置导出字段',
          botton: 0
        }
      } else {
        this.dialogFieldSet = {
          title: '显示字段',
          botton: 1
        }
      }
      this.fullScreenLoading = true;
      axiosBase({ reportFormId: this.otherSearch.reportFormId }, "/api/getuserreport").then(res => {
        this.fullScreenLoading = false;
        if (res && res.code == 0) {
          this.userReportId = res.data.userReportId;
          var content = res.data.content;
          this.showSets = [];
          this.checkShowSet = [];
          for (var i = 0; i < content.length; i++) {
            this.showSets.push(content[i]);
            if (content[i].checked) {
              this.checkShowSet.push(content[i])
            }
          }
          const index = this.showSets.findIndex(item => { return item.title === '新闻标题' })
          if (index === -1) {
            this.showSets.unshift({
              type: 'text',
              title: '新闻标题',
              name: '新闻标题',
              checked: false
            })
          }
          this.fieldChange(this.checkShowSet);
          // 批量导出报表走弹出新弹窗
          if (key == 0) {
            this.batch = {
              visible: true,
              title: '导出',
              operate: 'export',
              dateLen: this.bulkDeleteDataArr.length,
              batchQuery: this.otherSearch.query || '',
              center: content
            }
          } else {
            this.dialogFieldVisible = true;
          }

        }
      });
    },
    exportexcel(item) {
      var param = { type: 0, cateId: "-1", curpage: 0, pagesize: 0 }
      var checkShowSet = JSON.parse(JSON.stringify(this.checkShowSet));
      checkShowSet.forEach(e => {
        e.checked = true
      });
      param.content = JSON.stringify(checkShowSet)
      param.reportFormId = this.otherSearch.reportFormId;
      param.key = this.otherSearch.key;
      param.querys = this.otherSearch.querys;
      if (item.radio === 1) {
        param.approvingIds = this.bulkDeleteDataArr.map(its => its.approvingId).join(',')
      } else if (item.radio === 2) {
        param.query = this.otherSearch.query;
      } else if (item.radio === 3) {
        param.query = { 'date_timeof': item.time }
      }
      this.exportexcelLoading = true;
      // 从空间进入，需要传空间id
      if (this.isSpace) {
        let spaceId = typeof (this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        param.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof (this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        param.upaceid = upaceId
      }
      // 第三个参数是导出的接口过期时间
      axiosBase(param, "/api/exportreport", 60 * 1000 * 3).then(res => {
        this.exportexcelLoading = false
        if (res && res.code == 0) {
          filePreview({ url: res.data }, true)
          this.dialogFieldVisible = false;
        }
      });
    },
    FieldSubmit() {//显示设置确定
      this.showSets.forEach(el => {
        el.checked = false
        this.checkShowSet.forEach(ele => {
          if (el.name == ele.name) {
            el.checked = true
          }
        });
      });
      this.fullScreenLoading = true;
      axiosBase({ content: JSON.stringify(this.showSets), userReportId: this.userReportId }, "/api/updateuserreport").then(res => {
        if (res && res.code == 0) {
          // 过滤容器控件
          this.checkShowSet = this.checkShowSet.filter(item => {
            return item.type !== 'container'
          })
          this.tableKey = this.checkShowSet;
          this.menuListDatas[this.menuListActive].userReport.content = JSON.stringify(this.showSets)
          this.dialogFieldVisible = false;
          this.countTable()
          this.switClick()
        }
      });

    },
    //表格选项变化
    handleSelectionChange(val) {
      this.bulkDeleteDataArr = val;
    },
    //批量删除
    bulkDelete() {
      let param = {
        isAll: 2,
        approvingId: [],
      };
      this.bulkDeleteDataArr.forEach((el) => {
        param.approvingId.push(el.approvingId);
      });
      if (this.bulkDeleteDataArr.length > 0) {
        this.$confirm('确定要删除？', {
          confirmButtonClass: 'el-button--yeprimary',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.eletedFunction(param);//删除
        }).catch(() => {
        });
      } else {
        this.$message.error('请选择要删除的数据！');
      }
    },
    //删除
    tableDelete(el2) {
      let param = {
        isAll: 1,
        approvingId: el2.approvingId,
      };
      this.$confirm('确定要删除？', {
        confirmButtonClass: 'el-button--yeprimary',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.eletedFunction(param);//删除
      }).catch(() => {
      });
    },
    //删除方法
    eletedFunction(param) {
      let param2 = {
        approvingId: param.approvingId,
        approvalId: this.$route.query.approvalId || this.appid
      };
      let approvingIdArr = [];
      if (param.isAll == 1) {
        approvingIdArr.push(param.approvingId);
      } else {
        approvingIdArr = param.approvingId;
      }
      this.fullScreenLoading = true
      axiosBase(param2, "/api/deleteapproving").then(res => {
        this.fullScreenLoading = false
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: 'success'
          });
          approvingIdArr.forEach((el3) => {
            this.listData.data.forEach((el4, index) => {
              if (el3 == el4.approvingId) {
                this.listData.data.splice(index, 1,);
              }
            });
          });
          // 判断当前删除之后，是否没有数据，没有的话回退一页分页查询数据
          if (this.listData.data.length === 0 && this.otherSearch.curpage > 1) {
            this.otherSearch.curpage -= 1;
          }
          // 重新请求列表数据
          this.switClick();
          // parent.vueFun('resetRefresh')
          this.$emit('retRefresh')
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //修改
    tableUpdate(el3) {
      //清除限制
      const approvalId = el3.approvingId;
      let queryParam = {
        approvalId: this.menuListDatas[0].approvalId,
        modifyId: approvalId,
      };
      //是否显示头部
      if (!this.fromFrame) {
        queryParam.type = 1
      }
      this.$emit('upInput', queryParam)
    },
    //二维码生成方式
    onQrcodeCommand(command) {
      this.dialogvueqr = true
      this.$nextTick(function () {
        this.$refs.vueqrcoderef.onQrcodeCommand(command)
      })
    },
    formVerificationAndQuery(data) {
      this.querys = data && data.querys ? data.querys : '{}';
      if (!this.external) {
        //- 外链不需要短信验证
        this.smsVerifi(4);
      } else {
        this.toVeriQueryShow = false;
        this.judgeScene();
      }

    },
    // 短信验证
    smsVerifi(key) {
      let obj = {
        approvalId: this.$route.query.approvalId || this.appid,
        number: key // 验证参数为 1	个人数据查看短信验证 2 个人数据批量导出附件短信验证 3 个人数据批量导出报表短信验证 4 全校数据查看短信验证 5 全校数据批量导出附件短信验证 6 全校数据批量导出报表短信验证
      }
      openapiValidateapprovalsms(obj).then(res => {
        if (res.code === 0) {
          // bindcode 是否需要绑定手机号 smsverification 是否需要短信验证 phone 手机号
          if (res.data.smsverification && res.data.bindcode && !res.data.phone) {
            // 去绑定手机号
            this.fullScreenLoading = false;
            if (!this.transactionListFun) this.toSmsVerifi = true;
            this.$nextTick(() => {
              this.$refs.smsVerifi.iphoneBind({ isSmsView: true });
            })
          } else if (res.data.smsverification && res.data.phone) {
            // 去验证
            this.fullScreenLoading = false;
            if (!this.transactionListFun) this.toSmsVerifi = true;
            this.$nextTick(() => {
              this.$refs.smsVerifi.openSmsVer(res.data.phone, this.toSmsVerifi ? { isSmsView: true } : '');
            })
          } else {
            // 不需要验证
            if (key !== 4) {
              this.$nextTick(() => {
                this[this.transactionListFun](this.transactionListFun === 'getuserreport' ? 0 : '');
              })
            } else {
              this.toVeriQueryShow = false;
              this.judgeScene();
            }
          }
        }
      }).catch(err => {
        console.log('短信验证错误', err)
      })
    },
    // 短信验证返回
    smsRefersh() {
      // 如果是点击了按钮的
      if (this.transactionListFun) {
        this.isSmsFun[this.transactionListFun] = true;
        this.$nextTick(() => {
          this[this.transactionListFun](this.transactionListFun === 'getuserreport' ? 0 : '');
          delete this.transactionListFun;
        })
      } else {
        this.toSmsVerifi = false;
        // this.querys = e && e.querys ? e.querys : "{}";
        this.toVeriQueryShow = false;
        this.judgeScene();
      }
    },
    //- 表单·获取列表
    whetherShow(type) {
      console.log('whetherShow')
      //type这个是判断是iframe提交后更新数据
      let para = {
        approvalId: this.$route.query.approvalId || this.approvalId || this.appid,
        number: type,
      };
      // 从空间进入，需要传空间id
      if (this.isSpace) {
        const spaceId = typeof (this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        para.spaceid = spaceId;
      }
      else if (this.isUpace) {
        const upaceId = typeof (this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        para.upaceid = upaceId
      }
      getvalidateapproval(para).then(res => {
        if (res.data.property && res.data.property.length > 0) {
          this.fromFrame = true;
          this.fullScreenLoading = false;
          this.$nextTick(() => {
            this.$refs.VerificationAndQueryInputRef.showList(res);
          })
        } else {
          this.fromFrame = true;
          this.fullScreenLoading = false;
          this.scopeValidate = true
        }
      }).catch(err => {
        console.log('getapproval 接口出错', err)
      })
    },
    //- 正常流程场景操作
    judgeScene() {
      this.timeArr = generateTime()
      if (this.$route.query.approvalId || this.appid) {
        this.fullScreenLoading = false;
        this.fromFrame = true;

        this.$nextTick(() => {
          this.childTreeMethods({ approvalId: this.$route.query.approvalId || this.appid })
          this.topheight = '0px'

        })


        return
      }
      axiosBase({}, "/openapi/getapprovallistbyreportform").then(res => {
        if (!res.data || res.data.length == 0) {
          return
        }
        this.toVeriQueryShow = false;
        this.originalArr = JSON.parse(JSON.stringify(res.data))
        let a = searchNav(res.data)
        this.menuData = a;
        a[0].value[0] ? this.childTreeMethods(a[0].value[0]) : ''

      });
    },
  },
  mounted() {
    if (this.$route.query.external && this.$route.query.external !== 'undefined' || this.externals) {
      this.external = true;
    }
    // 如果有搜索条件的话直接过来搜索（只有带id 的url 才执行）
    const query = this.$route.query
    if (query.search && query.isAll) {
      let search = {}
      try {
        search = JSON.parse(this.$route.query.search)
      } catch (e) { console.log(e) }
      // const search = JSON.parse(this.$route.query.search)
      const obs = {}
      const approvalId = Number(this.$route.query.approvalId)
      for (const i of search.relevanceRules) {
        if (Number(i.formid) === approvalId && i.datas && i.datas.length > 0) {
          for (const a of i.datas) {
            if (a.target && a.target !== '申请人_relation-user' && a.target !== '单号_text') {
              // 状态、提交时间、归档状态格式不太一样，转化以下
              const obj = {
                '状态_status': 'status_status',
                '提交时间_date': 'date_timeof',
                '归档状态_status': 'archive_radio'
              }
              const target = obj[a.target] || a.target
              const val = Array.isArray(a.value) ? a.value : [a.value]
              obs[target] = val
            }
          }
        }
      }
      this.otherSearch.query = JSON.stringify(obs)
      this.searchQuery = obs
    } else if (query.search && query.iId) {
      // 这个代表是仪表盘过来的
      const search = (typeof query.search === 'string' ? JSON.parse(query.search) : query.search) || {}
      const obs = {}
      // const key = []
      const obj = {
        '归档状态_status': 'archive_radio',
        '申请人_relation-user': 'appuser_appuser'
      }
      const statusObj = {
        '待审批': 0,
        '已通过': 1,
        '未通过': 2,
        '已撤回': 3
      }
      for (const i in search) {
        const val = Array.isArray(search[i]) ? search[i] : [search[i]]
        // 数字值处理下
        if (i === 'status_status') {
          for (let s = 0; s < val.length; s++) {
            val[s] = statusObj[val[s]] || val[s]
          }
        } else if (i === 'date_timeof') {
          for (let s = 0; s < val.length; s++) {
            val[s] = timeFormatDate(new Date(val[s]).getTime())
          }
          if (val.length === 1) {
            val.push(val[0])
          }
        }
        if (obj[i]) {
          obs[obj[i]] = val
        } else {
          obs[i] = val
        }
      }
      this.otherSearch.query = JSON.stringify(obs)
      this.searchQuery = obs
    }
  },
  beforeUnmount() {
    this.heightCount = null
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.text-link {
  text-decoration: underline;
  color: #4e86ff;
  cursor: pointer;
}

::v-deep .stat-block {
  line-height: 23px;
  height: auto;
}

::v-deep .cell .el-button--small {
  padding-top: 0;
  padding-bottom: 0;
}

::v-deep .list-search input {
  background: #F2F2F2;
  border: none;
}

#table-list .el-popover {
  background: #312d28;
  font-size: 14px;
  color: #ffffff;
  border: 1px solid #312d28;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.verifi-img {
  padding-top: 10%;
  text-align: center;

  img {
    width: 100%;
  }

  p {
    font-size: 28px;
    padding: 20px 0;
    color: #277fd9;
  }
}

#table-list .el-popper[x-placement^="top"] .popper__arrow:after {
  border-top-color: #312d28;
}

#table-list .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#table-list .fourText {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

.tmTibs .el-tabs__nav {
  margin-left: 30px;
  padding: 10px 0;
}

.tmTibs .el-tabs__nav .el-tabs__item {
  font-size: 14px;
}

.el-table .header_style {
  background: #f8f9fb;
}

.row_style {
  color: #000;
  cursor: pointer;
}

.row_style_back {
  background-color: #dce8f3 !important;
}

::v-deep .row_style_back {
  background-color: #f1f8ff !important;

  &.el-table__row--striped>td {
    background-color: #ecf9ef !important;
  }
}

::v-deep .row_style {
  height: 36px;
}

.switBox {
  height: 100%;
}

.switBox .el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
.switBox .el-table__body tr.current-row>td,
.switBox .el-table__body tr.hover-row.current-row>td,
.switBox .el-table__body tr.hover-row.el-table__row--striped.current-row>td,
.switBox .el-table__body tr.hover-row.el-table__row--striped>td,
.switBox .el-table__body tr.hover-row>td {
  background-color: #fffcf0 !important;
}

.switBox .el-select .el-input.is-focus .el-input__inner {
  border-color: #19b359;
  background: #ffffff;
}

.switBox .el-input__inner {
  background: #f7f7f7;
  border: 1px solid transparent;
}

.switBox .el-range-input {
  background: #f7f7f7;
}

.switBox .none-input,
.el-range__close-icon {
  width: 0 !important;
}

.switBox .time-managementList input {
  border-color: transparent !important;
}

#listMom .el-form-item {
  margin-bottom: 0;
}
</style>
<style lang="scss" scoped>
::v-deep .batch {
  margin-left: 20px;
  display: inline-block;

  .title {
    margin: 0 4px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #333333;
    font-size: 14px;

    i {
      color: #999999;
    }
  }

  .el-icon-arrow-down {
    font-size: 10px;
  }
}

.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #965500;
  background: rgba(255, 253, 246, 1);
}

.cor-DC4 {
  color: #14adc4;
}

.cor-6DB {
  color: #1296db;
}

.cor-400 {
  color: #ffb400;
}

.button-list:hover .button-list-text {
  color: #965500;
}

.button-list {
  display: inline-block;
  margin-left: 25px;
  font-size: 16px;
}

.button-list-text {
  font-size: 14px;
}

.pos-list-mom-y {
  min-height: 65px;
  width: 100%;
}

.pos-list-mom {
  min-height: 38px;
  position: absolute;
  left: 7px;
  padding-left: 10px;
  z-index: 999;
  width: calc(100% - 20px);
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(235, 235, 235, 1);
  box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.16);
  padding-bottom: 15px;
}

.mom-text {
  color: #999999;
  font-size: 14px;
  padding-bottom: 11px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  display: inline-block;
}

.icon-bottom:after,
.icon-bottom-yes {
  content: ">>";
}

.icon-bottom {
  display: inline-block;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg) scale(1, 1.9);
  letter-spacing: -3px;
  font-size: 12px;
  color: #999999;
  position: relative;
  top: -3px;
}

.icon-bottom-yes {
  letter-spacing: -3px;
  font-size: 14px;
  color: #965500;
  display: block;
  -webkit-transform: rotate(-90deg) scale(1, 1.9);
  -moz-transform: rotate(-90deg) scale(1, 1.9);
  -ms-transform: rotate(-90deg) scale(1, 1.9);
  -o-transform: rotate(-90deg) scale(1, 1.9);
  transform: rotate(-90deg) scale(1, 1.9);
}

.mom-text-yes {
  display: inline-block;
  position: absolute;
  bottom: -35px;
  left: 50%;
  transform: translateX(-50%);
  width: 65px;
  height: 55px;
  padding-top: 10px;
  background: rgba(255, 246, 217, 1);
  border: 2px solid rgba(216, 166, 0, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 50%;
  text-align: center;
  color: #965500;
  font-size: 14px;
}

.mom-text-yes-title {
  padding-top: 8px;
  display: block;
}

.el-main {
  background: #fff;
  position: relative;
}

.menuList {
  background: #f4f4f9;
  height: 100%;
  position: relative;
  z-index: 99;
}

.menuList>p {
  position: absolute;
  background: #fff;
  width: 26px;
  height: 26px;
  right: -13px;
  border-radius: 50%;
  border: 1px solid #ddd;
  top: 46%;
  cursor: pointer;
  z-index: 5;
  text-align: center;
  line-height: 26px;
}

.menuList>p i {
  color: #4e86ff;
  font-size: 14px;
}

.menuList ul {
  padding-top: 18px;
  overflow: hidden;
}

.menuList ul li {
  margin-right: 10px;
  display: block;
  padding: 10px 0 10px 42px;
  cursor: pointer;
  color: #333;
}

.menuList ul li.active {
  background: #d2d2e1;
  color: #000;
}

.menuList ul li:hover {
  background: #e0e0eb;
}

.content {
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0px;
  overflow: auto;
  left: 225px;
}

.switBox {
  padding: 0 10px;
}

.demo-form-inline {
  float: left;
  width: 84%;
}

.page {
  position: absolute;
  bottom: 10px;
  padding: 6px 2%;
  right: 0;
  width: 96%;
  text-align: right;
  background: #fff;
  z-index: 5;
}

.el-icon--right {
  padding: 0 10px;
}

.nopadding {
  padding: 0 10px;
}

.dialog-body {
  padding: 16px;
}

.dialog-body .el-checkbox {
  padding-bottom: 12px;
}

.dialog-foot {
  padding: 10px 16px;
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;

  &-btn {
    flex: 1;
    text-align: right;
  }
}

.searchRow {
  height: 40px;
  overflow: hidden;
}

.searchBtn p {
  width: 90%;
  margin: 0 auto 10px;
}

.searchBtn p .el-button {
  width: 100%;
}

.searchList {
  width: 100%;
  height: 40px;
  margin: 0;
  padding: 0;
  overflow: hidden;

  .nav-top-filter {
    padding-left: 30px;
    color: #333333;

    &:hover {
      color: #4e86ff;
    }
  }
}

.searchMore {
  text-align: center;
  font-size: 20px;
  color: #4e86ff;
}

.searchMore i {
  cursor: pointer;
}

.list-mom {
  display: flex;
  flex-wrap: wrap;
}

.mom-text {
  color: #4b1a00;
  font-size: 14px;
}

.parting {
  width: 1px;
  height: 13px;
  background: #e5e5e5;
  display: inline-block;
  vertical-align: sub;
}

.goInfo {
  border: 1px solid #b66200;
  background: #fffcea;
  font-size: 14px;
  color: #b66200;
}

.bread-crumbs {
  font-size: 14px;
  color: #000;
  padding-top: 20px;
  padding-bottom: 20px;
}

.bread-crumbs span:nth-child(2) {
  margin-left: 15px;
}

.bread-crumbs span {
  margin-right: 15px;
}

.el-button {
  font-weight: 400;
}

.settingStyle {
  background: none;
  border: none;
  color: black;
}

.blockchain {
  padding-top: 8px;
  display: inline-block;

  .change {
    cursor: pointer;

    i {
      color: #4e86ff;
      font-size: 110%;
    }
  }
}

.inputArea {
  display: inline-block;
  vertical-align: top;
  margin-top: 6px;

  ::v-deep .el-input__inner {
    border-right: none;
    border-radius: 4px 0 0 4px;
  }

  ::v-deep .el-button {
    border-radius: 0 2px 2px 0;
    margin-left: -4px;
  }
}
</style>
